<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["TD"]["TD"]}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["TD"]["BN"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroup"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["TD"]["TT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_tt"
                                            :placeholder="this.utilGetDDLanguage('TD.TT')"
                                            v-model="str_FV[5].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["TD"]["BKN"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_bank"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            :placeholder="this.utilGetDDLanguage('TD.BKN')"
                                            v-model="str_FV[1].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["TD"]["BAN"]}} :</span>
                                <CInput size="sm"
                                        :value="str_FV[2].FV" @change="v => str_FV[2].FV = v" />
                            </div>

                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["TD"]["C"]}} :</span>
                                <treeselect :multiple="true"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('TD.C')"
                                            v-model="str_FV[4].FV" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['TD']['TDL']}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage["TD"]["BN"]}}<i @click="setSortTable('GPC')" :class="setSortLogo('GPC')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TD']['AD']}}<i @click="setSortTable('BAI')" :class="setSortLogo('BAI')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{this.getLanguage["TD"]["A"]}}<i @click="setSortTable('A')" :class="setSortLogo('A')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["TD"]["TT"]}}<i @click="setSortTable('TT')" :class="setSortLogo('TT')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['GL']['DT']}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage["TD"]["BN"]}}<i @click="setSortTable('GPC')" :class="setSortLogo('GPC')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TD']['AD']}}<i @click="setSortTable('BAI')" :class="setSortLogo('BAI')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{this.getLanguage["TD"]["A"]}}<i @click="setSortTable('A')" :class="setSortLogo('A')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["TD"]["TT"]}}<i @click="setSortTable('TT')" :class="setSortLogo('TT')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['GL']['DT']}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_tdl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_tdl" :class="data.MS == 1? 'blacklist-row': ''">
                            <td>{{ CountItem(index+1) }}</td>
                            <td>{{ data.GN }} ({{ data.GPC }})</td>
                            <td>
                                <span class="grid-line">{{ data.BN }}</span>
                                <span class="grid-line">{{ data.BA }}</span>
                                <span class="grid-line">{{ data.BAN }}</span>
                            </td>
                            <td :style="renderTransTypeStyle(data.TT)" class="tableCtnRight">{{ formatNumber(data.A, 2, data.CS) }}</td>
                            <td>
                                <span class="grid-line" :style="renderTransTypeStyle(data.TT)">{{ renderTransType(data.TT) }}</span>
                                <span class="grid-line">{{ data.R }}</span>
                            </td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import { required } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import { loadingFullScreen } from '@/modules/Constant.js';
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }, { F: "BI" }, { F: "BA" }, {
                    F: "CTS", FV: {
                        startDate: this.getTodayDate(),
                        endDate: this.getTodayEndDate()
                    }
                }, { F: "CI_csv", FA: true }, { F: "TT" }], //Filter Value
                arry_tdl: [], //transaction details list
                dd_agentgroup: [],//agent group option
                dd_currency: [],
                dd_tt: [], // transaction type
                dd_bank: [],
            }
        },
        created() {
            this.$parent.showSubMenu = 'B';
            this.$parent.showActiveMenu = 'B.TD';
            this.getTransDetailsLogList();
            this.getAgentGroup();
            this.getCurrencyList();
            this.getTTList();
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
        },
        watch: {
            getLanguage() {
                this.getTTList();
                this.getTransDetailsLogList();
            },
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[3].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[3].FV.endDate = "";
                    }
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getTransDetailsLogList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getTransDetailsLogList();
            },
            getTTList() {
                this.dd_tt = [{ id: '1', label: this.getLanguage['TD']['TT1'] }, { id: '2', label: this.getLanguage['TD']['TT2'] }];
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;
                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.str_FV[0].FV = agi;
                        this.searchPAgi = this.str_FV[0].FV;
                    } else {
                        this.searchPAgi = 0;
                    }

                    this.getDataApi(`/api/dd/bank/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_bank = d.dropdownlist
                            }
                        });
                    
                } else {
                    this.searchPAgi = 0;
                    this.str_FV[0].FV = null;
                }
                this.str_FV[4].FV = null;
                this.dd_currency = null;
                this.getCurrencyList();
            },
            getTransDetailsLogList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                this.getDataApi(`/api/bankacc/ll?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setTransDetailsLogList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setTransDetailsLogList(data) {
                this.arry_tdl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getTransDetailsLogList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            renderTransType(value) {
                return this.getLanguage['TD']['TT' + value];
            },
            renderTransTypeStyle(TransType) {
                if (TransType == 1 || TransType == 3) {
                    return { 'font-weight': 'bold', color: '#2eb85c' };
                }
                else if (TransType == 2 || TransType == 4 || TransType == 5) {
                    return { 'font-weight': 'bold', color: '#e55353' };
                }
            },
            clearDateRangeFilter() {
                this.str_FV[3].FV = {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        }

    }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Banks/TransactionDetails.vue